import get from 'lodash/get';
import { MODIFICATION_SEARCH_ALGORITHM_TYPES } from '../constants';

export default {
    computed: {
        algorithmType() {
            return get(this.settingValues, 'algorithm_type', MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast);
        },
    },
};
